module.exports = __webpack_public_path__ + "media/fonts/Inter-Light-02850f28.ttf";